export default "__VITE_ASSET__mWuTWSUm__"